import React from 'react';

import {MediaBrowserPanelConfig} from '../../../PanelMediaBrowser/common';
import {ClearSettingsRow} from '../components/ClearSettingsRow';
import {SettingsLevel} from './types';

export type MediaSettingsDrawerSectionOverridesProps = {
  /**
   * The configuration key for which to render overrides.
   */
  configKey: keyof MediaBrowserPanelConfig;
  /**
   * Object containing the number of overrides below each settings level for each config key.
   */
  numberOfOverridesBelow?: Partial<
    Record<
      SettingsLevel,
      Partial<Record<keyof MediaBrowserPanelConfig, number>>
    >
  >;
  /**
   * Object containing functions to clear overrides below each settings level.
   */
  clearOverridesBelow?: Partial<
    Record<SettingsLevel, (key: keyof MediaBrowserPanelConfig) => void>
  >;
};

/**
 * Component that renders override information and clear buttons for a specific config key.
 *
 * This component displays the number of overrides at each settings level and provides
 * clear buttons to remove those overrides.
 */
export const MediaSettingsDrawerSectionOverrides = ({
  configKey,
  numberOfOverridesBelow,
  clearOverridesBelow,
}: MediaSettingsDrawerSectionOverridesProps) => {
  return (
    <>
      {Object.keys(numberOfOverridesBelow ?? {}).map(level => {
        const levelKey = level as SettingsLevel; // We know that the keys are all SettingsLevel values
        if (numberOfOverridesBelow?.[levelKey]?.[configKey] === undefined) {
          return null;
        }
        return (
          <ClearSettingsRow
            key={levelKey}
            settingLevel={levelKey}
            count={numberOfOverridesBelow?.[levelKey]?.[configKey]}
            clearSetting={() => clearOverridesBelow?.[levelKey]?.(configKey)}
            settingKey={configKey}
          />
        );
      })}
    </>
  );
};
